// Module
var code = "<div id=\"rule-matched-items-page\"></div>";
// Exports
module.exports = code;